import { instances } from '../default-setup';

//SAML
export const getSAML = () => instances.get('settings/saml/');
export const createSAML = (data) => instances.post('settings/saml/', data);
export const updateSAML = (data) => instances.put('settings/saml/', data);
export const deleteSAML = () => instances.delete('settings/saml/');
